import React, { useState, useEffect } from "react";
import "./Rent.scss";
import { useStoreActions, useStoreState } from "easy-peasy";
import { YMaps, Map, Placemark } from "react-yandex-maps";
import Select from "../../components/Select/Select";
import Search from "../../components/Search/Search";
// import Filters from "../../components/Filters/Filters";
import { useHistory } from "react-router-dom";
import { getTitle } from "../../utils/helper";
import RentCard from "../../components/rentCard/rentCard";
import Fade from "@material-ui/core/Fade";
import Slider from "../../components/Slider/Slider";
import Checkbox from "../../components/Checkbox/Checkbox";
import { Link } from "react-router-dom";
const placeMarks = {};

function getCoord(str) {
  const arr = str.split("&");
  arr.pop();
  return arr;
}

const Marks = ({ rents }) => {
  const history = useHistory();
  const setIndex = useStoreActions((actions) => actions.rent.setIndex);
  const rentIndex = useStoreState((state) => state.rent.index);
  const goToRent = (slug) => {
    history.push("/rent/" + slug);
  };
  return (
    <>
      {rents.map((el, index) => (
        <Placemark
          onMouseEnter={() => setIndex(index)}
          onMouseLeave={() => setIndex(null)}
          onMouseDown={() => goToRent(el.slug)}
          instanceRef={(ref) => (placeMarks[index] = ref)}
          key={index}
          geometry={getCoord(el.map)}
          properties={{
            hintContent: `
            ${el.price} руб.\n
            ${el.area} м2.\n
            ${getTitle(el.map)}
            `,
          }}
          options={{
            preset:
              rentIndex == index
                ? "islands#violetCircleDotIcon"
                : "islands#violetCircleIcon",
          }}
          modules={["geoObject.addon.hint"]}
        />
      ))}
    </>
  );
};

const Rent = () => {
  const rent = useStoreState((state) => state.rent.rent);
  const noPhoto = useStoreState((state) => state.rent.noPhoto);
  const setNoPhoto = useStoreActions((actions) => actions.rent.setNoPhoto);
  const priceRange = useStoreState((state) => state.rent.priceRange);
  const smallPriceRange = useStoreState((state) => state.rent.smallPriceRange);
  const areaRange = useStoreState((state) => state.rent.areaRange);
  const setPriceRange = useStoreActions(
    (actions) => actions.rent.setPriceRange
  );
  const setSmallPriceRange = useStoreActions(
    (actions) => actions.rent.setSmallPriceRange
  );
  const setAreaRange = useStoreActions((actions) => actions.rent.setAreaRange);
  const rents = useStoreState((state) => state.rent.rents);
  const cities = useStoreState((state) => state.rent.cities);
  const city = useStoreState((state) => state.rent.city2);
  const getRents = useStoreActions((actions) => actions.rent.getRent);
  const setRent = useStoreActions((actions) => actions.rent.setRentOrSell);
  const setCity = useStoreActions((actions) => actions.rent.setCityIndex);
  const [filters, setFilters] = useState(false);
  const [sellOrRentInd, setsellOrRentInd] = useState(0);
  const sellOrRentArr = ["Cдача помещений в аренду", "Hепрофильные активы"];
  const [screen, setScreen] = useState(0);

  useEffect(() => {
    setScreen(window.innerWidth);
  }, []);

  const updateFilters = () => {
    getRents();
  };

  const selectCity = (index) => {
    setCity(index);
    getRents();
  };

  const rentOrSale = (index) => {
    setRent(index == "Hепрофильные активы" ? false : true);
    getRents();
    setsellOrRentInd(index == "Hепрофильные активы" ? 1 : 0);
  };

  return (
    <div className="rentMain">
      <div className="navLine"></div>
      <div className="container">
        <div className="controlls">
          <div className="selectContainer">
            <Select
              options={sellOrRentArr}
              value={sellOrRentArr[sellOrRentInd]}
              handleClick={rentOrSale}
            />
          </div>
          <div className="search">
            <Search />
          </div>
          <div className="citySelect">
            <Select
              options={cities.map((el) => el.title).sort()}
              value={city}
              handleClick={selectCity}
              long={true}
            />
          </div>
          <div
            className="btn red filterBtn"
            onClick={() => setFilters(!filters)}
          >
            <span className="material-icons">tune</span>
          </div>
        </div>
        <div className="mapContainer">
          <YMaps style={{ float: "right" }}>
            <Map
              width={screen > 1220 ? "calc(100% - 423px" : "100%"}
              height={screen > 1220 ? 700 : "80vw"}
              state={{
                center:
                  rents.length > 0
                    ? getCoord(rents[0].map)
                    : [57.151876, 65.55189],
                zoom: 11,
              }}
            >
              <Marks rents={rents} />
            </Map>
          </YMaps>
          <div className="mainItemList">
            <div className="btnContainer">
              <span>Коммерческая недвижимость</span>
              <div className="btn red" onClick={() => setFilters(true)}>
                фильтры <span className="material-icons">tune</span>
              </div>
            </div>
            <div className="cards">
              {rents.map((el, index) => (
                <Link
                  key={index}
                  to={"/rent/" + el.slug}
                  onMouseEnter={() => placeMarks[index].hint.open()}
                  onMouseLeave={() => placeMarks[index].hint.close()}
                >
                  <RentCard
                    index={index}
                    elem={el}
                    style={{
                      marginBottom: index < rents.length - 1 ? "20px" : "",
                    }}
                  />
                </Link>
              ))}
            </div>
            <Fade in={filters} timeout={500}>
              <div className="filters">
                <div className="controllsFilters">
                  <div className="selectContainerFilters">
                    <Select
                      options={sellOrRentArr}
                      value={sellOrRentArr[sellOrRentInd]}
                      handleClick={rentOrSale}
                    />
                  </div>
                  <div className="citySelectFilters">
                    <Select
                      options={cities.map((el) => el.title)}
                      value={city}
                      handleClick={selectCity}
                    />
                  </div>
                </div>
                <div className="sliderContainer">
                  <Slider
                    title={"Цена за м2, руб."}
                    max={rent ? 10000 : 500000}
                    values={smallPriceRange}
                    handleChange={setSmallPriceRange}
                  />
                </div>
                <div className="sliderContainer">
                  <Slider
                    title={"Цена, руб."}
                    max={rent ? 500000 : 100000000}
                    values={priceRange}
                    handleChange={setPriceRange}
                  />
                </div>
                <div className="sliderContainer">
                  <Slider
                    title={"Площадь, м2"}
                    max={1001}
                    values={areaRange}
                    handleChange={setAreaRange}
                  />
                </div>
                <div className="sliderContainer">
                  <Checkbox
                    title={"Только c фото"}
                    value={noPhoto}
                    handleChange={setNoPhoto}
                  />
                </div>
                <div
                  className="sliderContainer"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: "column",
                  }}
                >
                  <div
                    className="btn red"
                    onClick={() => {
                      updateFilters();
                      setFilters(false);
                    }}
                  >
                    показать объявления
                  </div>
                  <div className="btn red" onClick={() => setFilters(false)}>
                    закрыть
                  </div>
                </div>
              </div>
            </Fade>
          </div>
        </div>
        {/* <Filters applyFilters={updateFilters} /> */}
      </div>
    </div>
  );
};

export default Rent;
